import {Dashboard} from "./lq_js_common/dashboard/dashboard";
import {TimePicker} from "./components/time_picker";
import {loadTrainingSnapshot, applyTrainingSnapshot} from "./training_snapshot";
import {loadTrainingCopy, initTrainingOverlay} from "./training_overlay";
import {ShaperSiteThroughput} from "./dashlets/shaper_site/shaper_site_throughput";
import {ShaperSiteActiveCircuits} from "./dashlets/shaper_site/shaper_site_active_circuits";
import {ShaperSitePackets} from "./dashlets/shaper_site/shaper_sites_packets";
import {ShaperSiteRetransmits} from "./dashlets/shaper_site/shaper_site_retransmits";
import {ShaperSiteCake} from "./dashlets/shaper_site/shaper_site_cake";
import {ShaperSiteRtt} from "./dashlets/shaper_site/shaper_site_rtt";
import {ShaperSiteRttHisto} from "./dashlets/shaper_site/shaper_site_rtt_histo";
import {ShaperSiteCombinedThroughput} from "./dashlets/shaper_site/shaper_site_combined_throughput";
import {ShaperSiteCombinedRetransmits} from "./dashlets/shaper_site/shaper_site_combined_retransmits";
import {ShaperSiteCombinedRtt} from "./dashlets/shaper_site/shaper_site_combined_rtt";
import {ShaperSiteRttHeatmap} from "./dashlets/shaper_site/shaper_site_heatmap_rtt";
import {ShaperSiteRetransmitsHeatmap} from "./dashlets/shaper_site/shaper_site_heatmap_retransmits";
import {ShaperSiteCapacityHeatmap} from "./dashlets/shaper_site/shaper_site_heatmap_capacity";
import {ShaperSiteHeaderDashlet} from "./dashlets/shaper_site/shaper_site_header";
import {ShaperSiteContextSankey} from "./dashlets/shaper_site/shaper_site_context_sankey";
import {ShaperSiteUpgradeAnalysis} from "./dashlets/shaper_site/shaper_site_upgrade_analysis";
import {
    ExecutiveGlobalHeatmapDashlet,
    ExecutiveHelpersDashlet,
    ExecutiveQooHeatmapDashlet,
    ExecutiveRetransmitsHeatmapDashlet,
    ExecutiveRttHeatmapDashlet,
    ExecutiveSnapshotDashlet,
    ExecutiveUtilizationHeatmapDashlet,
} from "./dashlets/executive/executive_dashlets";
import {renderTrainingNavigation} from "./components/navbar";
import {createExplainController, setupLibbyExplainButton} from "./helpers/ai_explain";

const SNAPSHOT_URL = "/training/snapshots/shaper_site.json";
const COPY_URL = "/training/training_copy.json";

function forceDarkMode() {
    try {
        localStorage.setItem("theme", "dark");
    } catch (e) {
        // no-op
    }
    document.documentElement.setAttribute("data-bs-theme", "dark");
    document.body.classList.add("dark-mode");
}

function buildTagToTabIndex(layout) {
    const map = {};
    layout.tabs.forEach((tab, idx) => {
        tab.dashlets.forEach((dashlet) => {
            if (map[dashlet.tag] === undefined) {
                map[dashlet.tag] = idx;
            }
        });
    });
    return map;
}

forceDarkMode();
window.nodeId = "0";
window.siteId = "0";

const defaultLayout = {
    version: 2,
    tabs: [
        {
            name: "Executive Summary",
            dashlets: [
                {tag: "siteUpgradeAnalysis", size: 12},
                {tag: "executiveSnapshot", size: 12},
                {tag: "executiveGlobalHeatmap", size: 12},
                {tag: "executiveRttHeatmap", size: 6},
                {tag: "executiveRetransmitHeatmap", size: 6},
                {tag: "executiveUtilizationHeatmap", size: 6},
                {tag: "executiveQooHeatmap", size: 6},
                {tag: "executiveHelpers", size: 12},
            ]
        },
        {
            name: "Overview",
            dashlets: [
                {tag: "siteContext", size: 12},
            ]
        },
        {
            name: "Site",
            dashlets: [
                {tag: "siteActiveCircuits", size: 3},
                {tag: "siteThroughput", size: 9},
                {tag: "sitePackets", size: 6},
                {tag: "siteRetransmits", size: 6},
                {tag: "siteCake", size: 6},
                {tag: "siteRtt", size: 6},
                {tag: "siteRttHistogram", size: 4},
            ]
        },
        {
            name: "Children",
            dashlets: [
                {tag: "siteCombinedThroughput", size: 12},
                {tag: "siteCombinedRetransmits", size: 12},
                {tag: "siteCombinedRtt", size: 12},
            ]
        },
        {
            name: "Heatmaps",
            dashlets: [
                {tag: "siteHeatmapRtt", size: 4},
                {tag: "siteHeatmapRetransmits", size: 4},
                {tag: "siteHeatmapCapacity", size: 4},
            ]
        }
    ],
    activeTab: 0
};

const dashletMenu = [
    {name: "Executive Snapshot", tag: "executiveSnapshot", size: 12},
    {name: "Executive Global Heatmap", tag: "executiveGlobalHeatmap", size: 12},
    {name: "Executive RTT Heatmap", tag: "executiveRttHeatmap", size: 6},
    {name: "Executive Retransmits Heatmap", tag: "executiveRetransmitHeatmap", size: 6},
    {name: "Executive Utilization Heatmap", tag: "executiveUtilizationHeatmap", size: 6},
    {name: "Executive QoO Heatmap", tag: "executiveQooHeatmap", size: 6},
    {name: "Executive Helper Views", tag: "executiveHelpers", size: 12},
    {name: "Upgrade Analysis", tag: "siteUpgradeAnalysis", size: 12},
    {name: "Active Circuits", tag: "siteActiveCircuits", size: 3},
    {name: "Site Throughput", tag: "siteThroughput", size: 9},
    {name: "Site Packets", tag: "sitePackets", size: 6},
    {name: "Site Retransmits", tag: "siteRetransmits", size: 6},
    {name: "Site CAKE", tag: "siteCake", size: 6},
    {name: "Site RTT", tag: "siteRtt", size: 6},
    {name: "Site RTT Histogram", tag: "siteRttHistogram", size: 4},
    {name: "Site Combined Throughput", tag: "siteCombinedThroughput", size: 12},
    {name: "Site Combined Retransmits", tag: "siteCombinedRetransmits", size: 12},
    {name: "Site Combined RTT", tag: "siteCombinedRtt", size: 12},
    {name: "Site Heatmap RTT", tag: "siteHeatmapRtt", size: 4},
    {name: "Site Heatmap Retransmits", tag: "siteHeatmapRetransmits", size: 4},
    {name: "Site Heatmap Capacity", tag: "siteHeatmapCapacity", size: 4},
    {name: "Site Context", tag: "siteContext", size: 12}
];

function widgetFactory(widgetName, count) {
    let widget = null;
    switch (widgetName) {
        case "siteActiveCircuits": widget = new ShaperSiteActiveCircuits(count); break;
        case "siteThroughput": widget = new ShaperSiteThroughput(count); break;
        case "sitePackets": widget = new ShaperSitePackets(count); break;
        case "siteRetransmits": widget = new ShaperSiteRetransmits(count); break;
        case "siteCake": widget = new ShaperSiteCake(count); break;
        case "siteRtt": widget = new ShaperSiteRtt(count); break;
        case "siteRttHistogram": widget = new ShaperSiteRttHisto(count); break;
        case "siteCombinedThroughput": widget = new ShaperSiteCombinedThroughput(count); break;
        case "siteCombinedRetransmits": widget = new ShaperSiteCombinedRetransmits(count); break;
        case "siteCombinedRtt": widget = new ShaperSiteCombinedRtt(count); break;
        case "siteHeatmapRtt": widget = new ShaperSiteRttHeatmap(count); break;
        case "siteHeatmapRetransmits": widget = new ShaperSiteRetransmitsHeatmap(count); break;
        case "siteHeatmapCapacity": widget = new ShaperSiteCapacityHeatmap(count); break;
        case "siteHeader": widget = new ShaperSiteHeaderDashlet(count); break;
        case "siteContext": widget = new ShaperSiteContextSankey(count); break;
        case "siteUpgradeAnalysis": widget = new ShaperSiteUpgradeAnalysis(count); break;
        case "executiveSnapshot": widget = new ExecutiveSnapshotDashlet(count, "site"); break;
        case "executiveGlobalHeatmap": widget = new ExecutiveGlobalHeatmapDashlet(count, "site"); break;
        case "executiveRttHeatmap": widget = new ExecutiveRttHeatmapDashlet(count, "site"); break;
        case "executiveRetransmitHeatmap": widget = new ExecutiveRetransmitsHeatmapDashlet(count, "site"); break;
        case "executiveUtilizationHeatmap": widget = new ExecutiveUtilizationHeatmapDashlet(count, "site"); break;
        case "executiveQooHeatmap": widget = new ExecutiveQooHeatmapDashlet(count, "site"); break;
        case "executiveHelpers": widget = new ExecutiveHelpersDashlet(count, "site"); break;
        default: {
            console.log("I don't know how to construct a widget of type [" + widgetName + "]");
            return null;
        }
    }
    return widget;
}

const dashboard = new Dashboard("dashboard", "training_shaperSiteDashboard_v1", defaultLayout, widgetFactory, dashletMenu, false, "", false);
dashboard.build();

// Inline Libby insights strip. Training has no chatbot backend, so the
// controller renders the structured summary locally.
function explainableReadyDashlets() {
    return dashboard.dashlets.filter((d) => typeof d.canExplain === "function" && d.canExplain()
        && typeof d.isExplainReady === "function" && d.isExplainReady());
}
const explainController = createExplainController({
    dashboard,
    page: "shaper_site",
    getContext: () => ({node_id: String(window.nodeId), site_id: String(window.siteId)}),
    getExplainable: explainableReadyDashlets,
});
setupLibbyExplainButton(explainController);

window.timeGraphs = [];
window.timePicker = new TimePicker("timePicker");

(async () => {
    const tagToTabIndex = buildTagToTabIndex(defaultLayout);
    try {
        const snapshot = await loadTrainingSnapshot(SNAPSHOT_URL);
        if (snapshot?.ids?.node_id !== undefined) {
            window.nodeId = String(snapshot.ids.node_id);
        }
        if (snapshot?.ids?.site_id !== undefined) {
            window.siteId = String(snapshot.ids.site_id);
        }
        if (snapshot?.data?.shaper_navigation) {
            const nav = snapshot.data.shaper_navigation;
            renderTrainingNavigation(nav.blob || [], window.nodeId, nav.is_flat || false);
        } else {
            renderTrainingNavigation([], window.nodeId, false);
        }
        const applied = applyTrainingSnapshot(dashboard, snapshot);
        if (applied === 0) {
            console.warn("Training snapshot is empty.");
        }
        explainController.markNeedsExplain();
    } catch (err) {
        console.error(err);
    }

    try {
        const copy = await loadTrainingCopy(COPY_URL);
        initTrainingOverlay({ copy, pageKey: "shaper_site", dashboard, tagToTabIndex });
    } catch (err) {
        console.error(err);
    }
})();
